import { useMemo, useState } from "react";
import { CATEGORIES, listProducts } from "../lib/productsApi";
import { img } from "../data/images";
import { APS_URL } from "../data/chapters";
import { TLink } from "../components/TransitionProvider";
import ImageWithCaption from "../components/ImageWithCaption";
import Footer from "../components/Footer";
import Button from "../components/Button";

export default function Products() {
  const [cat, setCat] = useState("all");
  const items = useMemo(() => listProducts(cat), [cat]);

  return (
    <>
      <section className="ph">
        <p className="t-cap ph-kicker" data-rv="">02 — Products</p>
        <h1 className="t-display ph-title">
          <span className="mask"><span className="rise" style={{ "--d": "100ms" }}>Pick a place</span></span>
          <span className="mask"><span className="rise hero-light" style={{ "--d": "220ms" }}>to begin.</span></span>
        </h1>
        <div className="ph-row">
          <p className="t-lg ph-intro" data-rv="" style={{ "--d": "300ms" }}>
            Subscription development and automation, on a rhythm that fits you. Each one has its own page with everything included, so you know exactly what you're choosing.
          </p>
          <ImageWithCaption className="ph-figure" image={img("caption")} index="Fig. 03" title="Made to be used" text="Product photography placeholder." />
        </div>
      </section>

      <section className="list">
        <div className="filters" role="tablist" aria-label="Filter products" data-rv="">
          {[{ id: "all", short: "All" }, ...CATEGORIES].map((c) => (
            <button key={c.id} type="button" role="tab" aria-selected={cat === c.id} className={`chip${cat === c.id ? " on" : ""}`} onClick={() => setCat(c.id)}>
              {c.short}
            </button>
          ))}
          <span className="t-cap filters-count">{String(items.length).padStart(2, "0")} products</span>
        </div>

        <ul className="rows rows--index" key={cat}>
          {items.map((p, i) => (
            <li key={p.id} data-rv="" style={{ "--d": `${Math.min(i, 6) * 55}ms` }}>
              <TLink to={`/products/${p.id}`} label={p.name} className="row row--index">
                <span className="row-num t-cap">{p.number}</span>
                <span className="row-main">
                  <span className="row-name t-h2">{p.name}</span>
                  <span className="row-sum t-body">{p.summary}</span>
                </span>
                <span className="row-tag t-cap">{p.tag}</span>
                <span className="row-price t-lg">{p.price}<em>{p.cadence}</em></span>
                <span className="row-arrow" aria-hidden="true">→</span>
              </TLink>
            </li>
          ))}
        </ul>

        <aside className="aps-note" data-rv="">
          <p className="t-cap">Working with sensitive data?</p>
          <p className="t-lg">Healthcare and enterprise platforms are handled by our Advanced Platform Services team, with HIPAA-conscious architecture and SOC 2-aligned operations.</p>
          <Button variant="text" href={APS_URL}>Meet APS</Button>
        </aside>
      </section>

      <Footer heading="Not sure where to start?" text="Book a strategy call, or tell us what you're building and we'll point you the right way." />
    </>
  );
}
